import {CREDIT_STATUS, GENDERS, PAYMENT_TYPES, TRANSACTIONS_STATUS} from "@/utils/constants";
import {refactorNumber} from "@/utils/pureFunctions";
import {moneyToString} from 'short-money'
var moment = require('moment');

export default {
  parseDate(val) {
    const date = new Date(val)
    return date.toLocaleDateString('RU-ru')
  },
  parseDateWithTimeZone(val) {
    return moment(val).add(5,'hours').format("DD.MM.YYYY")
  },
  parseTimeWithTimeZone(val) {
    return moment(val).add(5,'hours').format("DD.MM.YYYY HH:mm:ss")
  },
  genderParse(val) {
    const gender = GENDERS.find(item => item.value === val)
    if (!gender) return ''
    return gender.text
  },
  money(val) {
    let num = val ? Math.round(val *100) / 100 : null;
    return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') : 0
  },
  hidePartPhone(val) {
    if (!val) return '';
    const phoneNumber = refactorNumber({prefix: "+998 ", removeSymbol: '-', number: val}).split('')
    phoneNumber.splice(7, 3, ' * * * ')
    return phoneNumber.join('')
  },
  parsePaymentType(val) {
    const paymentType = PAYMENT_TYPES.find(item => item.value === val)
    if (!paymentType) return ''
    return paymentType.text
  },
  parseCreditStatus(value) {
    const status = CREDIT_STATUS.find(item => item.value === value)
    if (!status) return ''
    return status.text
  },
  parseTransactionStatus(value) {
    const status = TRANSACTIONS_STATUS.find(item => item.value === value)
    if (!status) return ''
    return status.text
  },

  numberToString(value) {
    return moneyToString(value)
  }

}
